import { Stack, useTheme, CircularProgress } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';
import { green, red } from '@mui/material/colors';

interface Props {
    isLoading: boolean;
    data?: { completed: number; rejected: number };
}

const CompletionRateChart = ({ isLoading, data }: Props) => {
    const { palette } = useTheme();

    if (isLoading) {
        return (
            <Stack flex={1} padding={4} alignItems="center" justifyContent="center">
                <CircularProgress />
            </Stack>
        )
    }

    if (!data) return null;

    const chartData = [
        { name: 'Completadas', value: data.completed, color: green[500] },
        { name: 'Rechazadas', value: data.rejected, color: red[500] },
    ];

    return (
        <ResponsiveContainer width="100%" height={250}>
            <PieChart
                height={400}
                width={400}
                style={{ fontFamily: "'Fira Sans', sans-serif" }}
            >
                <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    innerRadius={40}
                    outerRadius={60}

                    dataKey="value"
                >
                    {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                </Pie>

                {/* Texto centrado con el porcentaje de completadas */}
                <text
                    x="50%"
                    y="48%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    style={{
                        fontSize: '18px',
                        fill: palette.text.primary,
                        marginTop: '-10px'
                    }}
                >
                    {`${data.completed.toFixed(0)}%`}
                </text>

                <Legend iconType="circle" />
            </PieChart>
        </ResponsiveContainer>
    )
}

export default CompletionRateChart;
